import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Loader from "react-loader-spinner";
import "./CustomerPaymentPrint.css";
import { Button } from "antd";
import CustomerPaymentPrintHeader from "./CreditMemoReportHeader/CustomerPaymentPrintHeader";
import { getCustomerPaymentPrint } from "../../redux/actions/customerPaymentPrint.action";
import { getOneCustomerPaymentLine } from "../../redux/actions/customerPaymentLine.action";
import { TabTitle } from "../../utils/GeneralFunction";
import moment from "moment";
import numeral from "numeral";
import { currencySymbol } from "../../utils/constants";

const CustomerPaymentPrint = ({ token }) => {
  TabTitle("Customer Payment Report")
  const dispatch = useDispatch();
  const { customerPaymentPrint } = useSelector((state) => state);

  const [data, setData] = useState([]);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();

  let payment_header_id = query.get("payment_header_id");

  const headerData =
    customerPaymentPrint && customerPaymentPrint?.payload?.data[0];

  const values = {
    payment_header_id: payment_header_id,
  };

  useEffect(() => {
    dispatch(getCustomerPaymentPrint(token, values));
    dispatch(getOneCustomerPaymentLine(token, payment_header_id)).then((res) => {
      if (res.type === "GET_ONE_PAY_CUSTOMER_PAYMENT_LINE_SUCCESS") {
        setData(res.payload.data);
      }
    });
  }, [payment_header_id]);

  const handlePrint = () => {
    const css = '@page { size: landscape; margin: 2mm 10mm !important; }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  const totalInvoiceAmount = data
    ?.reduce((sum, item) => sum + (Number(item.invoice_amount) || 0), 0);

  if (customerPaymentPrint?.loading) {
    return <>
      <div className='loaderDiv' >
        <Loader
          type="Grid"
          color="#212121"
          height={40}
          width={40}
        />
      </div>
    </>
  }

  return (
    <div className="__customer_payment_report">
      <table width="100%">
        <thead>
          <tr>
            <td>
              <CustomerPaymentPrintHeader />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="no-print">
            <td>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "114px" }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Body myData={data} payment_amount={headerData?.payment_amount} totalInvoiceAmount={totalInvoiceAmount} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const Body = ({ myData, totalInvoiceAmount, payment_amount }) => {
  return (
    <>
      <div className="__content">
        <div className="__list_items">
          <table width="100%">
            <thead>
              <tr>
                <th
                  style={{
                    width: "36px",
                  }}
                >
                  S.No
                </th>
                <th
                  style={{
                    width: "88px",
                  }}
                >
                  Transaction Type
                </th>
                <th
                  style={{
                    width: "80px",
                  }}
                >
                  Transaction No
                </th>
                <th
                  style={{
                    width: "80px",
                  }}
                >
                  Transaction Date
                </th>
                <th
                  style={{
                    width: "80px",
                  }}
                >
                  Payment Term
                </th>
                <th
                  style={{
                    width: "80px",
                  }}
                >
                  Gender
                </th>
                <th
                  style={{
                    width: "80px",
                  }}
                >
                  PO#
                </th>
                <th
                  style={{
                    width: "80px",
                  }}
                >
                  EDI#
                </th>
                <th
                  style={{
                    width: "80px",
                  }}
                >
                  Discount Taken
                </th>
                <th
                  style={{
                    width: "80px",
                  }}
                >
                  Payment
                </th>
              </tr>
            </thead>
            <tbody>
              {myData?.map((it, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td
                      style={{
                        marginLeft: "0",
                      }}
                    >
                      {it.transaction_type}
                    </td>
                    <td>
                      {it.invoice_header_no}
                    </td>
                    <td>
                      {moment(it.invoice_date).format("MM-DD-YYYY")}
                    </td>
                    <td>{it.term_name}</td>
                    <td>{it.gender_name}</td>
                    <td>{it.reference_no}</td>
                    <td>{it.edi}</td>
                    <td style={{ textAlign: 'end' }}>{currencySymbol}{numeral(it.discount_taken).format("0.00")}</td>
                    <td style={{ textAlign: 'end' }}>{currencySymbol}{numeral(it.amount_paid).format("0.00")}</td>
                  </tr>
                );
              })}
              <tr>
                <td colSpan={10} style={{ height: "15px", border: 0 }}></td>
              </tr>
              <tr>
                <td colSpan={8} style={{ border: 0 }}></td>
                <td><p>Payment Amount</p></td>
                <td style={{ textAlign: "end" }}>{currencySymbol}{numeral(payment_amount && payment_amount).format("0.00")}</td>
              </tr>
              <tr>
                <td colSpan={8} style={{ border: 0 }}></td>
                <td><p>Applied Amount</p></td>
                <td style={{ textAlign: "end" }}>{currencySymbol}{numeral(totalInvoiceAmount).format("0.00")}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div >
    </>
  )
}





export default CustomerPaymentPrint;